require('./brokerHireInvestmentFundDetails.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const classNames = require('classnames');
// @ helpers
const { FormattedText } = require('core/i18n').i18n;
const { toCamelCase } = require('utilities/stringHelper');
const IbanHelper = require('utilities/ibanHelper');
const Immutable = require('immutable');
// @ constants
const {
    API_ENTERPRISE_NUMBER,
    API_CENTER,
    BROKER_FUNDS_SUBSCRIPTION_CONTRACT_FORMAT
} = require('constants/index');
const { getFormattedString } = require('utilities/currencyHelper');
const { INTERVENER_CODES, INTERVENER_DESCRIPTIONS } = require('constants/interveners')
class BrokerHireInvestmentFundDetails extends React.Component {
    buildAccount(index) {
        const { immAccount, immInvestmentFunds } = this.props;
        const accountNumberPrefix = `${API_ENTERPRISE_NUMBER}${API_CENTER}`;
        const accountContractNumber = immAccount.get('contractNumber');
        const accountProductNumber = immAccount.get('product');
        const accountCodbban = immAccount.getIn(['ibanComplex', 'codbban']);
        const accountControlDigit = accountCodbban.substring(8, 10);
        const fullAccountNumber = IbanHelper.formatAccountTextWithSpaces(
            `${accountNumberPrefix}${accountControlDigit}${accountProductNumber}${accountContractNumber}`,
            BROKER_FUNDS_SUBSCRIPTION_CONTRACT_FORMAT
        );
        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        let accountHolders;
        if(isSubscription){
            const contractNumber = immInvestmentFunds.getIn(['contractFund', 'contractNumber'])
            accountHolders = immInvestmentFunds.getIn([
                'steps',
                0,
                'intervenersByContract',
                contractNumber,
                'listadoIntervinientes',
                'intervinientes'
            ])?.filter((intervener) => {
                return intervener.get('tipoIntervencion').trim() === INTERVENER_DESCRIPTIONS['01']
            }).map((holder, ind) => {
                const spanClassName = classNames({
                    'hire-investment-details__account-holder' : ind !== 0,
                });
                return(
                    <span className={spanClassName} key={ind}>{holder.get('nomInterviniente')}</span>
                );
            });
        }else{
            accountHolders = immInvestmentFunds.getIn(['steps', 0, 'interveners'])
            .filter((intervener)=>{
                return intervener.get('interventionType') === INTERVENER_CODES.holder
            }).map((intervener, ind) => {
                    const spanClassName = classNames({
                        'hire-investment-details__account-holder' : ind !== 0,
                    });
                    return(
                        <span className={spanClassName} key={ind}>{intervener.get('name')}</span>
                    );
                });
        }
        const accountName = immAccount.getIn(['catalogData', 'product']);

        const fundContractPrefix = `${API_ENTERPRISE_NUMBER}${API_CENTER}`;
        const fundContractNumber =
            immInvestmentFunds.getIn(['contractFund', 'contractNumber']) || '';
        const fundProductNumber = immInvestmentFunds.getIn(['contractFund', 'product']) || '';
        const fundControlDigit = immInvestmentFunds.getIn(['contractFund', 'controlDigit']);
        const fullFundContractNumber = IbanHelper.formatAccountTextWithSpaces(
            `${fundContractPrefix}${fundControlDigit}${fundProductNumber}${fundContractNumber}`,
            BROKER_FUNDS_SUBSCRIPTION_CONTRACT_FORMAT
        );
        const accountAlias = immAccount.get('alias');

        return (
            <div key={index} className="hire-investment-details__center col-lg-4">
                <div className="hire-investment-details__center-panel">
                    <div className="hire-investment-details__center-panel-fist-block">
                        <div className="hire-investment-details__text">
                            {accountAlias}
                        </div>
                        <div className="hire-investment-details__bold-text">
                            {toCamelCase(accountName)}
                        </div>
                        <div className="hire-investment-details__secondary-text">
                            {fullAccountNumber}
                        </div>
                    </div>
                    <div className="hire-investment-details__secondary-text">
                        <FormattedText
                            value="brokerHireInvestmentStep2-contract"
                            className="hire-investment-details__secondary-text"
                        />
                        <div className="hire-investment-details__secondary-text hire-investment-details__inline">
                            {fullFundContractNumber}
                        </div>
                    </div>
                    <div className="hire-investment-details__secondary-text">
                        <FormattedText value="brokerHireInvestmentStep2-holder" />
                        {accountHolders}
                    </div>
                </div>
            </div>
        );
    }

    buildContributionData() {
        const { immInvestmentFunds } = this.props;
        const labelPeriodicity = {
            "Weekly": 'brokerContributionFundStep1-weeklyPeriodicity',
            "Monthly": 'brokerContributionFundStep1-monthlyPeriodicity',
            "Quarterly": 'brokerContributionFundStep1-quarterlyPeriodicity',
            "Semiannual": 'brokerContributionFundStep1-semestralPeriodicity',
            "Annual": 'brokerContributionFundStep1-annualPeriodicity',
        }
        const contributionAmount = immInvestmentFunds.getIn(['steps', 1, 'amount'])
        const periodicity = immInvestmentFunds.getIn(['steps', 1, 'periodicityValue'])
        const currency = immInvestmentFunds.getIn(['steps', 0, 'accountAmount', 'currency'])
        const date = immInvestmentFunds.getIn(['steps', 1, 'selectedDate'])
        const currencyObject = Immutable.Map().merge({
            amount: contributionAmount,
            currency: currency
        });
        const isSubscription = immInvestmentFunds.getIn(['steps', 0 ,'isSubscription'], false);
        const skipContribution = immInvestmentFunds.get('skipContribution')
        const amountInvestment = getFormattedString(currencyObject);

        if( periodicity && !isSubscription && !skipContribution && contributionAmount > 0) {
            return (
                <div className='hire-investment-details__contribution-container'>
                    <div className='hire-investment-details__contribution-amount'>
                        <FormattedText
                            value="brokerHireInvestmentStep2-amountContribution"
                            injectedStrings={[amountInvestment]}
                        />
                        <FormattedText value={labelPeriodicity[periodicity]} />
                    </div>
                    <div className='hire-investment-details__contribution-date'>
                        <FormattedText
                            value="brokerHireInvestmentStep2-dateContribution"
                        />
                    </div>
                    <div className='hire-investment-details__contribution-value-date'>
                        {date.format('DD MMM YYYY')}
                    </div>
                </div>
            )
        }
    }

    render() {
        const { immFlagBasedFeatures } = this.props;
        const table = this.props.columns.map((column, index) => {
            if (column === 'account') {
                return this.buildAccount(index);
            } else
                return (
                    <div
                        key={index}
                        className="hire-investment-details__left col-lg-3 hire-investment-details__text"
                    >
                        <div className="hire-investment-details__left-text">
                            {column !== 'contribution' && <FormattedText value={column} />}
                        </div>
                        {column === 'contribution' && immFlagBasedFeatures.get('wealth_funds_periodic_contributions') ? (
                            this.buildContributionData()
                        ) : (
                            <div className="hire-investment-details__bold-text">
                            {this.props.columnsContent[index]}
                        </div>
                        )}
                    </div>
                );
        });

        return (
            <div className="hire-investment-details">
                <div className="row">
                    {table}
                </div>
            </div>
        );
    }
}

BrokerHireInvestmentFundDetails.propTypes = {
    columns: PropTypes.array.isRequired,
    columnsContent: PropTypes.array.isRequired,
    immAccount: PropTypes.object.isRequired,
    immInvestmentFunds: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
};

module.exports = BrokerHireInvestmentFundDetails;
